/** The public shop (cps-ecom). */
export const STOREFRONT_URL = (
    process.env.REACT_APP_STOREFRONT_URL || "https://catelynpetshop.com"
).replace(/\/$/, "");

/** "catelynpetshop.com" — for showing addresses to staff. */
export const STOREFRONT_HOST = STOREFRONT_URL.replace(/^https?:\/\//, "");

/** A brand's page on the shop. */
export const brandPageUrl = (slug: string): string =>
    `${STOREFRONT_URL}/shop?brand=${encodeURIComponent(slug)}`;

/** The shop, or one category's page on it. */
export const shopPageUrl = (categorySlug?: string | null): string =>
    categorySlug
        ? `${STOREFRONT_URL}/shop/${encodeURIComponent(categorySlug)}`
        : `${STOREFRONT_URL}/shop`;

/** A product's page on the shop: /products/<slug>. */
export const productPageUrl = (slug: string): string =>
    `${STOREFRONT_URL}/products/${encodeURIComponent(slug)}`;

/** A campaign's page on the shop: /offers/<slug>. */
export const campaignPageUrl = (slug: string): string =>
    `${STOREFRONT_URL}/offers/${encodeURIComponent(slug)}`;
